<ngx-loading [show]="processLoading" [config]="{ backdropBorderRadius: '14px', fullScreenBackdrop: true }">
</ngx-loading>
<notifier-container></notifier-container>

<ng-template #verifyPhoneTmpl>
  <ng-container *ngIf="mobileFormValidation">
    <form class="container-verification" [formGroup]="mobileFormValidation">
      <h5>Enter Verification Code</h5>
      <div class="row adjust-padding">
        <div class="col-lg-12 pr-0">
          <mat-form-field appearance="fill" [floatLabel]="false">
            <input matInput formControlName="code" maxlength="6" />
            <mat-hint>We have sent you an SMS code message, please enter the code here to continue.
            </mat-hint>
            <mat-error *ngIf="mobileFormValidation.hasError('minLength') || mobileFormValidation.hasError('required')">
              Code is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 pr-0">
          <button class="Gydhwj" [disabled]="mobileFormValidation.invalid" mat-button (click)="verifyPhone()">
            Verify
          </button>
        </div>
      </div>
      <ngx-loading [show]="isModalLoading" [config]="{ backdropBorderRadius: '14px', fullScreenBackdrop: true }">
      </ngx-loading>
    </form>
  </ng-container>
</ng-template>
<div class="profile-details" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="25px">
  <!-- <div class="col-3 sidebar" style="display:none;">
    <ul>
      <li>Edit Profile</li>
      <li><a (click)="testredirect()" href="javascript:">Payment & Payout Method</a></li>
    </ul>
  </div> -->


  <div class="form-user" fxFlexOrder="1" fxFlexOrder.lt-md="2">

    <div class="profile-header">
      <div>
        <h4>Account</h4>
        <label class="subtitle">Update your profile and manage your account.</label>
      </div>
    </div>

    <form class="profile-forms" [formGroup]="formValues">
      <div class="row adjust-padding">
        <div class="col-lg-5">
          <mat-form-field>
            <input matInput placeholder="First Name" (input)="checkForProfileUpdates('firstName')"
              formControlName="firstName" />
          </mat-form-field>
        </div>
        <div class="col-lg-7">
          <mat-form-field>
            <input matInput placeholder="Last Name" (input)="checkForProfileUpdates('lastName')"
              formControlName="lastName" />
          </mat-form-field>
        </div>
      </div>
      <div class="row adjust-padding">
        <div class="col-lg-8">
          <mat-form-field>
            <input matInput placeholder="Display name" (input)="checkForProfileUpdates('displayName')"
              formControlName="displayName" />
          </mat-form-field>
        </div>
      </div>
      <div class="row adjust-padding">
        <div class="col-lg-8">
          <mat-form-field>
            <input matInput placeholder="Email" value=" " formControlName="email" />
          </mat-form-field>

          <div class="email-verified-status" *ngIf="user && user.emailVerified">
            <label>
              Email Verified
            </label>
          </div>
        </div>
        <div class="col-lg-12" *ngIf="user && !user.emailVerified">
          <button class="btn-sm" mat-button (click)="sendVerificationEmail()">
            Send Verification Email
          </button>
        </div>
      </div>
      <div class="row adjust-padding">
        <div class="col-lg-12">
          <mat-form-field [floatLabel]="'always'">
            <textarea matInput placeholder="About Me" value=" " name="aboutMe" formControlName="aboutMe"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row adjust-padding">
        <div class="col-lg-12 address-wrap">
          <mat-form-field [floatLabel]="'always'">
            <textarea matInput placeholder="Address" value=" " formControlName="address"></textarea>
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="row adjust-padding">
          <div class="col-lg-12 gender-wrap">
            <label>Gender</label>
            <mat-radio-group aria-label="Select an option" formControlName="gender">
              <mat-radio-button value="male">Male</mat-radio-button>
              <mat-radio-button value="female">Female</mat-radio-button>
            </mat-radio-group>
          </div>
        </div> -->

      <div class="row adjust-padding" formGroupName="birthDay">
        <div class="col-lg-5">
          <mat-form-field>
            <mat-label>Date of birth</mat-label>
            <select matNativeControl formControlName="month">
              <optgroup label="Day">
                <ng-container *ngFor="let val of listOfMonths">
                  <option [value]="val.value">{{val.month}}</option>
                </ng-container>
              </optgroup>
            </select>
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field>
            <mat-label> </mat-label>
            <select matNativeControl formControlName="day">
              <optgroup label="Day">
                <option *ngFor="let day of days" value="{{ day + 1 }}">{{ day + 1 }}
                </option>
              </optgroup>
            </select>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field>
            <mat-label> </mat-label>
            <select matNativeControl formControlName="year">
              <optgroup label="Year">
                <option [value]="y" *ngFor="let y of birthYears">{{ y }}</option>
              </optgroup>
            </select>
          </mat-form-field>
        </div>
      </div>
      <div class="row adjust-padding">
        <div class="col-lg-3">
          <mat-form-field [floatLabel]="'always'">
            <mat-label>Phone Number
            </mat-label>
            <select matNativeControl formControlName="phoneCode">
              <optgroup label="Country Code">
                <option value="+65" selected>SG (+65)</option>
                <option value="+63">PH (+63)</option>
              </optgroup>
            </select>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field>
            <input type="number" matInput placeholder=" " value=" " formControlName="mobile" />
          </mat-form-field>
        </div>
        <div class="col-lg-6" *ngIf="user && !user.mobileVerified && user.mobile != null && user.mobile == getPhone()">
          <button class="Gydhwj" mat-button (click)="sendPhoneVerification()">
            Verify Phone
          </button>
        </div>
        <div class="col-lg-12" *ngIf="user && user.mobileVerified">
          <label>
            <svg class="feather verified">
              <use xlink:href="/assets/img/feather-sprite.svg#check-circle" />
            </svg> Phone Verified
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <button class="Gydhwj" [disabled]="formValues.invalid" mat-button (click)="updateProfile(formValues)">
            Update
          </button>
        </div>

      </div>
    </form>
  </div>


  <div class="picture" fxFlexOrder="2" fxFlexOrder.lt-md="1">
    <div class="row">
      <div class="col-lg-12">
        <label>Profile Picture</label>
        <div class="upload-picture">
          <div (mouseover)="isHovered = !isHovered" (mouseout)="isHovered = !isHovered" class="profile-pic"
            [ngStyle]="{background: 'url(' + user?.photoURL + ')'}">
            <div class="upload-container" [hidden]="isHovered">
              <i (click)="upload.click()" class="fa fa-camera upload-button" aria-hidden="true"></i>
            </div>
            <input type="file" [hidden]="true" (input)="uploadProfilePic($event.target.files)" #upload />
          </div>
        </div>
      </div>
    </div>
  </div>

</div>